/* Roam & Rufus: keeps the free leashes free in every cart.

   Two Shopify discounts make the gift leashes free: one per single harness, two per two-pack. They trip over each other:
   1. When a single harness and a two-pack are in the same cart, Shopify only applies the two-pack discount, so the single
      harness's leash is charged. In that case the single harness carries its free leash on its own line as "Free leash: <colour>"
      (no separate leash line), and the two-pack keeps its two free leash lines. When the cart is no longer mixed, the leash
      goes back to being its own free line.
   2. When a shopper also buys a leash on its own, Shopify can make that one free and charge the gift one. The gift leashes are
      then put back in last, one per line, so the gifts are the free ones.
   The store's "Your free-leash discount could not be applied" error is only let through when fewer leashes are free than the
   cart has earned. */
(function(){
'use strict';
const gift=window.RRGift;
if(!gift||typeof gift.reconcile!=='function'||gift.rrFix)return;
gift.rrFix=2;
const ROOT=(window.RR&&window.RR.root)||'/';
const PROP='Free leash';
const original=gift.reconcile;
const JSON_HEADERS={'Content-Type':'application/json',Accept:'application/json'};
const ids=p=>new Set(((p&&p.variants)||[]).map(v=>Number(v.id)));
const catalog=()=>(window.RR&&window.RR.catalog)||{};
const isSingle=it=>ids(catalog().harness).has(Number(it.variant_id));
const isPack=it=>ids(catalog().bundle).has(Number(it.variant_id));
const isLeash=it=>it.handle==='roam-leash';
const isGift=it=>isLeash(it)&&!!(it.properties&&it.properties.Gift);
const carried=it=>!!(it.properties&&it.properties[PROP]);
const groupOf=it=>(it.properties&&it.properties._rr_gift_group)||'';
const isMixed=cart=>(cart.items||[]).some(isSingle)&&(cart.items||[]).some(isPack);
const tidy=s=>String(s||'').replace(/^leash\s*-\s*/i,'').trim().toLowerCase();
const pretty=s=>tidy(s).replace(/(^|\s)[a-z]/g,m=>m.toUpperCase());
const colourOf=it=>pretty((it.variant_options&&it.variant_options[0])||String(it.variant_title||'').split('/')[0]);
// leashes the cart still needs as free lines: two per two-pack, one per single harness that is not carrying its leash
const owed=cart=>(cart.items||[]).reduce((n,it)=>n+(isPack(it)?2*it.quantity:isSingle(it)&&!carried(it)?it.quantity:0),0);
// leashes Shopify has actually made free
const freeUnits=cart=>(cart.items||[]).filter(isLeash).reduce((n,it)=>n+(it.original_price>0?Math.round((it.original_line_price-it.final_line_price)/it.original_price):0),0);
const charged=cart=>(cart.items||[]).filter(it=>isGift(it)&&it.final_line_price>0);
const signature=cart=>(cart.items||[]).map(it=>it.key+'x'+it.quantity).sort().join('|');
async function read(){
  const r=await fetch(ROOT+'cart.js',{headers:{Accept:'application/json'}});
  if(!r.ok)throw Error('cart');
  return r.json();
}
async function post(path,body){
  const r=await fetch(ROOT+path,{method:'POST',headers:JSON_HEADERS,body:JSON.stringify(body)});
  if(!r.ok)throw Error(path);
}
let leashProduct=null;
function leashVariants(){
  if(!leashProduct)leashProduct=fetch(ROOT+'products/roam-leash.js',{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).then(p=>(p&&p.variants)||[]).catch(()=>[]);
  return leashProduct;
}
async function variantFor(colour){
  const want=tidy(colour),all=(await leashVariants()).filter(v=>v.available);
  return all.find(v=>tidy(v.option1)===want)||null;
}
async function defaultColour(harness){
  const own=tidy(harness.variant_options&&harness.variant_options[0]);
  return (await variantFor(own))?pretty(own):'Black';
}
// 1. mixed carts: single harnesses carry their free leash as a line property; otherwise it is its own free line
async function arrange(cart){
  const items=cart.items||[],singles=items.filter(isSingle);
  if(isMixed(cart)){
    const updates={},changes=[];
    for(const s of singles){
      const group=groupOf(s),mine=group?items.filter(it=>isGift(it)&&groupOf(it)===group):[];
      if(carried(s)&&!mine.length)continue;
      let colours=carried(s)?String(s.properties[PROP]).split(',').map(x=>x.trim()).filter(Boolean):[];
      mine.forEach(g=>{updates[g.key]=0;if(!carried(s))for(let i=0;i<g.quantity;i++)colours.push(colourOf(g));});
      while(colours.length<s.quantity)colours.push(await defaultColour(s));
      colours=colours.slice(0,s.quantity);
      if(!carried(s)||String(s.properties[PROP])!==colours.join(', '))changes.push({id:s.key,quantity:s.quantity,properties:Object.assign({},s.properties,{[PROP]:colours.join(', ')})});
    }
    if(!Object.keys(updates).length&&!changes.length)return cart;
    for(const c of changes)await post('cart/change.js',c);
    if(Object.keys(updates).length)await post('cart/update.js',{updates});
    return read();
  }
  const back=singles.filter(carried);
  if(!back.length)return cart;
  // leashes left behind by a harness or two-pack that is no longer in the cart
  const groups=new Set(items.filter(it=>isSingle(it)||isPack(it)).map(groupOf).filter(Boolean)),orphans={};
  items.forEach(it=>{if(isGift(it)&&groupOf(it)&&!groups.has(groupOf(it)))orphans[it.key]=0;});
  if(Object.keys(orphans).length)await post('cart/update.js',{updates:orphans});
  const adds=[];
  for(const s of back){
    const props=Object.assign({},s.properties),colours=String(props[PROP]).split(',').map(x=>x.trim()).filter(Boolean);
    props[PROP]='';
    await post('cart/change.js',{id:s.key,quantity:s.quantity,properties:props});
    for(const colour of colours.slice(0,s.quantity)){
      const v=await variantFor(colour);
      if(v)adds.push({id:v.id,quantity:1,properties:Object.assign({Gift:'Halloween free leash'},groupOf(s)?{_rr_gift_group:groupOf(s)}:{})});
    }
  }
  if(adds.length)await post('cart/add.js',{items:adds});
  return read();
}
// 2. a leash bought on its own took the discount: put the gift leashes back in last, one per line
async function regift(cart){
  const gifts=(cart.items||[]).filter(isGift),updates={},items=[];
  gifts.forEach(it=>{updates[it.key]=0;for(let i=0;i<it.quantity;i++)items.push({id:it.variant_id,quantity:1,properties:Object.assign({},it.properties,{_rr_gift_n:String(items.length+1)})});});
  await post('cart/update.js',{updates});
  await post('cart/add.js',{items});
  return read();
}
let running=null,settled='';
gift.reconcile=function(cart){
  if(running)return running;
  running=(async()=>{
    let now=cart;
    try{now=await arrange(cart);}catch(e){try{now=await read();}catch(e2){now=cart;}}
    // the store counts one leash line per single harness; harnesses that carry their leash are left out of what it is shown
    const hidden=it=>isSingle(it)&&carried(it),hide=(now.items||[]).some(hidden);
    const view=hide?Object.assign({},now,{items:now.items.filter(it=>!hidden(it))}):now;
    try{
      const result=await original(view);
      return hide?await read():result;
    }catch(err){
      if(!err||String(err.message).indexOf('free-leash discount')<0)throw err;
      try{
        now=await read();
        if(charged(now).length&&freeUnits(now)>=owed(now)&&settled!==signature(now)){now=await regift(now);settled=signature(now);}
      }catch(e){throw err;}
      if(charged(now).length&&freeUnits(now)<owed(now))throw err;
      return now;
    }
  })();
  const done=()=>{running=null;};
  running.then(done,done);
  return running;
};
})();
